import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";

// Matches per round in the leagues; cups (CL, WC, EC) have up to 18 and no fisse/doppie limit.
export const MATCHES_PER_ROUND = { SA: 10, PL: 10, PD: 10, BL1: 9, FL1: 9 };
export const isCup = (comp) => !MATCHES_PER_ROUND[comp];
const nums = (max) => Array.from({ length: max + 1 }, (_, i) => String(i));

export const normalizeLimits = (l, comp) => {
  const n = MATCHES_PER_ROUND[comp];
  if (!n) return { ...l, unlimited: true, esatti: Math.min(l.esatti ?? 1, 18) };
  if (l.unlimited) return { ...l, esatti: Math.min(l.esatti ?? 1, n) };
  const fisse = Math.min(l.fisse ?? Math.ceil(n / 2), n);
  return { ...l, fisse, doppie: n - fisse, esatti: Math.min(l.esatti ?? 1, n) };
};

export const limitsError = (l, comp) => {
  const n = MATCHES_PER_ROUND[comp];
  if (!n || l.unlimited) return null;
  return l.fisse + l.doppie !== n ? `Fisse + doppie devono fare ${n} (ora ${l.fisse + l.doppie})` : null;
};

const Pick = ({ label, value, max, onChange, testId, disabled }) => (
  <label className="space-y-1">
    <span className="text-xs text-slate-400">{label}</span>
    <Select value={String(value ?? 0)} onValueChange={(v) => onChange(Number(v))} disabled={disabled}>
      <SelectTrigger data-testid={testId} className="h-11 bg-[#0A0D14] border-[#26334D]"><SelectValue /></SelectTrigger>
      <SelectContent className="bg-[#121824] border-[#26334D] max-h-64">
        {nums(max).map((n) => <SelectItem key={n} value={n} data-testid={`${testId}-${n}`}>{n}</SelectItem>)}
      </SelectContent>
    </Select>
  </label>
);

export const LimitsFields = ({ value, onChange, testPrefix, competition }) => {
  const n = MATCHES_PER_ROUND[competition];
  const cup = !n;
  const err = limitsError(value, competition);
  const toggle = () => onChange(normalizeLimits({ ...value, unlimited: !value.unlimited, fisse: value.fisse ?? Math.ceil(n / 2) }, competition));
  return (
    <div className="space-y-3">
      <button type="button" onClick={cup ? undefined : toggle} disabled={cup} data-testid={`${testPrefix}-unlimited-toggle`}
        className={`h-9 px-4 rounded-full border text-sm font-semibold transition-colors ${value.unlimited ? "bg-emerald-500 border-emerald-500 text-[#0A0D14]" : "border-[#26334D] text-slate-300 hover:border-emerald-500/60"} ${cup ? "cursor-not-allowed opacity-60" : ""}`}>
        Nessun limite su fisse e doppie{cup ? " (automatico)" : ""}
      </button>
      {cup && <p className="text-xs text-slate-500">Nelle coppe le partite per giornata cambiano (fino a 18): fisse e doppie sono sempre libere.</p>}
      <div className="grid grid-cols-3 gap-3">
        {!value.unlimited && (
          <>
            <Pick label="Fisse" value={value.fisse} max={n} onChange={(v) => onChange({ ...value, fisse: v })} testId={`${testPrefix}-limit-fisse`} />
            <Pick label="Doppie" value={value.doppie} max={n} onChange={(v) => onChange({ ...value, doppie: v })} testId={`${testPrefix}-limit-doppie`} />
          </>
        )}
        <Pick label="Risultati esatti" value={value.esatti} max={n || 18} onChange={(v) => onChange({ ...value, esatti: v })} testId={`${testPrefix}-limit-esatti`} />
      </div>
      {err && <p className="text-xs text-red-400" data-testid={`${testPrefix}-limits-hint`}>{err}</p>}
    </div>
  );
};
